export default {
  /**
  * Save key to local storage
  * @param key {String}
  * @param value {Object}
  * @returns {*}
  */
  saveKey(key, value) {
    if (window && window.localStorage) {
      return window.localStorage.setItem(key, JSON.stringify(value));
    }
  },

  /**
  * Get key from local storage
  * @param key {String}
  * @returns {*}
  */
  getKey(key) {
    if (window && window.localStorage) {
      return JSON.parse(window.localStorage.getItem(key));
    }
  },

  /**
  * Delete key from local storage
  * @param key {String}
  * @returns {*}
  */
  deleteKey(key) {
    if (window && window.localStorage) {
      return window.localStorage.removeItem(key);
    }
  },
}



// WEBPACK FOOTER //
// localStorage.js